// For Bootstrap you can specify which plugins you need:
// import { Tooltip, Toast, Popover } from 'bootstrap';
// Alternatively, if you only need just a few of our plugins, you may import plugins individually as needed:
// import Alert from 'bootstrap/js/dist/alert';
import { Carousel, Modal, Dropdown } from "bootstrap";
import Accordion from "common/js/script/accordion";
import Bilder from "common/js/script/bilder";
import Forms from "common/js/script/forms";
import InitVue from "./vue/initvue";
import Video from "common/js/script/video";
import Utbildning from "./script/utbildning";
import Observe from "./script/observe";
import Karusell from "./script/karusell";
import Sok from "common/js/script/sok";
import Projektsida from "./script/projektsida";
import Startsida from "./script/startsida";
import changeEpiQuickNavigatorEditLink from "common/js/script/changeEpiQuickNavigatorEditLink";

import "common/js/script/globals";
import "common/js/script/menu";

InitVue.initVue();
Accordion.initAccordion();
Video.initVideo();
Utbildning.initUtbildning();
Bilder.initBilder();
Karusell.initKarusell();
Sok.initSok();
Projektsida.initProjektsida();
Startsida.initStartsida();
Forms.showReloadButton();
changeEpiQuickNavigatorEditLink.init();

// Monitor changes in main and mainbody
// caused by navigation in menus
Observe.observe();
